import { render } from "./ReportSalesCashier.vue?vue&type=template&id=5823f012&scoped=true"
import script from "./ReportSalesCashier.vue?vue&type=script&lang=js"
export * from "./ReportSalesCashier.vue?vue&type=script&lang=js"

import "./ReportSalesCashier.vue?vue&type=style&index=0&id=5823f012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5823f012"]])

export default __exports__